import React, {PureComponent} from "react";
import { Button } from "antd";
import Geocoder from 'react-map-gl-geocoder'

import introFormat from "../../content/intro-screen/intro-screen"
import {CORILogo} from "../utilsJSX";
import config from '../../content/config'
import {coriLink} from "../../constants";


export default class LocalPerspectiveStartScreen extends PureComponent {
	constructor(props) {
		super(props)
		this.geocoderContainerRef = React.createRef()
	}
	
	_onHandleResult = (result) => {
		this.props._handleSelectLocationFromGeocoder(result)
		this.props.onCloseStartScreen()
	}
	
	_onHandleSelectPresetOptionToExplore = ({lat, lon, name, stateName, fullLocation}) => {
		this.props.selectCommunityAndFetchItsGeoIdLookupData({
			lat,
			lon,
			stateName,
			fullLocation,
			namelsad: name,
		})
		this.props.onCloseStartScreen()
	}
	
	render() {
		const { initialLoadOfMapHasCompleted } = this.props
		
		return (
			<div className='start-screen-full-page-background'>
				<div className="start-screen">
					
					<a id="cori-link" style={{position: 'absolute', left: '10px', top: '10px'}} href={coriLink} target="_blank" rel="noopener noreferrer">
						<CORILogo />
					</a>
					
					<div className={'start-screen-title-container'}>
						<div className="start-screen-title">{introFormat.titleText}</div>
					</div>
					
					<div className={`community-selection-wrapper ${initialLoadOfMapHasCompleted ? '' : ' map-still-loading'}`}>
						<div className='explore-box' style={{display: (introFormat.hideExploreOptions === true) ? 'none' : 'initial'}}>
							<div className='explore-title'>{introFormat.exploreText}</div>
							{initialLoadOfMapHasCompleted && introFormat.exploreOptions.map((opt,i) => (
								<div key={i} className='explore-container'>
									<Button onClick={() => this._onHandleSelectPresetOptionToExplore(opt)}>
										<div className='location-title'>{opt.name}</div>
										<div className='location-state'>{opt.stateName}</div>
									</Button>
								</div>
							))}
						</div>
						
						<div
							className='geocoder-search-bar'
							ref={this.geocoderContainerRef}
						/>
						<Geocoder
							containerRef={this.geocoderContainerRef}
							mapRef={this.props._mapRef}
							onViewportChange={this.props._handleGeocoderViewportChange}
							onResult={this._onHandleResult}
							mapboxApiAccessToken={config.MAPBOX_TOKEN}
							position="top-right"
							countries={'US'}
							clearAndBlurOnEsc={true}
							clearOnBlur={true}
							placeholder={initialLoadOfMapHasCompleted ? introFormat.searchText : 'Loading map...'}
						/>
					</div>
				</div>
			</div>
		)
	}
}
